import { Accordion, AccordionTab } from "primereact/accordion";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { FallbackCasesTab } from "./FallbackCasesTab";
import { HowBorrowingWorks } from "./HowBorrowingWorks";

export const BORROWING_SECTION_HEADER = "How fallbacks work";

/**
 * CLE-3047 — Eligibility › Fallbacks, as ONE view (Mike, 2026-10-29: "the two sub tabs is actually overkill"):
 *
 * - at the top, a collapsible "How fallbacks work" section (`HowBorrowingWorks`), COLLAPSED by default: the
 *   substitution rules by service line, the same for every hospital;
 * - below it, the live checks that actually fell back (`FallbackCasesTab`): co-insurance or copay substituted from
 *   another service line or taken from earlier patients, with why and a link to the estimate.
 *
 * PrimeReact's Accordion unmounts a collapsed tab's content, so the rules query runs only once the section is
 * expanded. The section's state is not kept in the URL. The old sub-tabs' `?view=` is still READ so existing links
 * work: `view=rules` opens the section expanded; `view=checks`, no `view` or anything else opens it collapsed.
 */
export function FallbacksTab() {
  const [params] = useSearchParams();
  const [activeIndex, setActiveIndex] = useState<number | null>(() =>
    params.get("view") === "rules" ? 0 : null
  );

  return (
    <div data-testid="fallbacksTab">
      <Accordion
        className="mb-3"
        activeIndex={activeIndex}
        onTabChange={(event) => setActiveIndex(event.index as number | null)}
      >
        <AccordionTab
          header={BORROWING_SECTION_HEADER}
          data-testid="fallbacks.howBorrowingWorks"
        >
          <HowBorrowingWorks />
        </AccordionTab>
      </Accordion>
      <FallbackCasesTab />
    </div>
  );
}
